import { HttpHelper } from '../../_commons/Helpers/HttpHelper';

export interface ILiveNotification{
    liveNotificationId:number,
    notificationTitle:string,
    notificationContent:string
}
export type IGetResponseData = ILiveNotification;
export type IGetAllResponseData = ILiveNotification[];
const apiRoot="/api/CMS/LiveNotificaitonCMS"

const Get = (id: number , token: string): Promise<IGetResponseData | null> => {


    return HttpHelper.Get(`${apiRoot}/${id}`, token).then(async (resp) => {
        if (resp.status === 200) {
            let data: IGetResponseData = await resp.json();
            return data;
        } else {
            return null;
        }

    })
}
const GetAll = ( token: string): Promise<IGetAllResponseData| null> => {


    return HttpHelper.Get(`${apiRoot}/All`, token).then(async (resp) => {
        if (resp.status === 200) {
            let data: IGetAllResponseData = await resp.json();
            return data;
        } else {
            return null;
        }

    })
}


const Update = (action: "ADD" | "EDIT", obj: ILiveNotification, token: string): Promise<boolean> => {
    if (action === "ADD")
        return HttpHelper.PostJSON(`${apiRoot}/Add`, obj, token).then(async (resp) => {
            if (resp.status === 200)
                return true;
            else
                return false;
        })
    else
        return HttpHelper.PostJSON(`${apiRoot}/Edit`, obj, token).then(async (resp) => {
            if (resp.status === 200)
                return true;
            else
                return false;
        })
}
interface IDeleteReqModel {
    Id: number
}
const Delete = (reqData: IDeleteReqModel, token: string): Promise<boolean> => {
    return HttpHelper.PostJSON(`${apiRoot}}/Delete`, reqData, token).then(async (resp) => {
        if (resp.status === 200)
            return true;
        else
            return false;
    })
}





export const LiveNotificationCMSApi = {
    Get,
    GetAll,
    Update,
    Delete
}